import { SUGGESTION_TYPES } from '@trustero/trustero-api-web/lib/recommend/recommend_pb'

export const GUIDANCE_DISMISSED_CONFIG: Record<SUGGESTION_TYPES, boolean> = {
  [SUGGESTION_TYPES.UNKNOWN]: false,
  [SUGGESTION_TYPES.HOWTOHANDLEIT]: false,
  [SUGGESTION_TYPES.EVIDENCE]: false,
  [SUGGESTION_TYPES.TESTS]: false,
  [SUGGESTION_TYPES.MARKETPLACE]: false,
  [SUGGESTION_TYPES.GUIDANCE]: false,
  [SUGGESTION_TYPES.AUTOMATED_EVIDENCE]: false,
}

export const GUIDANCE_SECTION_AVAILABLE_CONFIG: Record<
  SUGGESTION_TYPES,
  boolean
> = {
  [SUGGESTION_TYPES.UNKNOWN]: false,
  [SUGGESTION_TYPES.HOWTOHANDLEIT]: true,
  [SUGGESTION_TYPES.EVIDENCE]: false,
  [SUGGESTION_TYPES.TESTS]: false,
  [SUGGESTION_TYPES.MARKETPLACE]: false,
  [SUGGESTION_TYPES.GUIDANCE]: true,
  [SUGGESTION_TYPES.AUTOMATED_EVIDENCE]: true,
}

export enum SUGGESTIONS {
  UNKNOWN = 'unkown',
  GENERAL_GUIDANCE = 'generalGuidance',
  TAILORED_GUIDANCE = 'tailoredGuidance',
  SUGGESTED_EVIDENCE = 'suggestedEvidence',
  SUGGESTED_TESTS = 'suggestedTests',
}
